export const TEXTURES_BASE_FOLDER = "realistic";
export const CARRIERS_CONFIG_FILE_NAME = "carriers-config.json";
export const CARRIERS_TEXTURES_FILE_NAME = "carriers-textures.json";
export const CONTAINERS_PATH = "containers";
export const FORMAT_LOGO = "png";
export const FORMAT_TEXTURE = "webp";
export const FORMAT_THUMB = "webp";
export const FOLDER_NAME_LOGOS = "logos";
export const FOLDER_NAME_TEXTURES = "textures";
export const FOLDER_NAME_THUMBS = "thumbs";
export const FOLDER_CONTAINER_MODELS = "containerModels";

export const TEXURES_CONFIG_FULL_PATH = `${TEXTURES_BASE_FOLDER}/${CARRIERS_CONFIG_FILE_NAME}`;
export const TEXURES_RESULT_FULL_PATH = `${TEXTURES_BASE_FOLDER}/${CARRIERS_TEXTURES_FILE_NAME}`;
export const CONTAINER_MODELS_FULL_PATH = `${TEXTURES_BASE_FOLDER}/${FOLDER_CONTAINER_MODELS}`;
export const CONTAINER_MODELS_OBJ_FULL_PATH = `${CONTAINER_MODELS_FULL_PATH}/obj`;
export const CONTAINER_MODELS_MTL_FULL_PATH = `${CONTAINER_MODELS_FULL_PATH}/textures`;

export const LOGOS_FULL_PATH = `${TEXTURES_BASE_FOLDER}/${CONTAINERS_PATH}/${FOLDER_NAME_LOGOS}`;
